module.exports = __webpack_public_path__ + "media/images/pic/brodno/gallery/2021/polkolonie/big/5-7ea238980392800da5b3ab347fcbb025.webp";